import { Coordinates } from '../../modules/stores/types';

export type AutocompleteSuggestion = {
  mainText: string;
  secondaryText: string;
  id: string;
};

type StringSearchReturns = {
  places: AutocompleteSuggestion[];
  error?: Error;
};

export class PlacesAndAutocomplete {
  static isPlacesAvailable() {
    if (typeof google === 'undefined') {
      return false;
    }

    return Boolean(google?.maps?.places);
  }

  static async getPlacesByStringSearch(search: string): Promise<StringSearchReturns> {
    try {
      const { AutocompleteSuggestion } = google.maps.places;

      const request: google.maps.places.AutocompleteRequest = {
        input: search,
        includedRegionCodes: ['US'],
        region: 'US',
      };

      const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

      return {
        places: (suggestions ?? [])
          .map((item) => ({
            id: item.placePrediction?.placeId,
            mainText: item.placePrediction?.mainText?.text,
            secondaryText: item.placePrediction?.secondaryText?.text,
          }))
          .filter((item): item is AutocompleteSuggestion => !!item.id && !!item.mainText && !!item.secondaryText),
      };
    } catch (error) {
      return { places: [], error: error as Error };
    }
  }

  static async getPlaceCoordinates(placeId: string): Promise<Coordinates | null> {
    try {
      const { Place } = (await google.maps.importLibrary('places')) as google.maps.PlacesLibrary;
      const placeLibrary = new Place({ id: placeId, requestedRegion: 'US' });
      const { place } = await placeLibrary.fetchFields({
        fields: ['location'],
      });

      const lat = place.location?.lat();
      const lng = place.location?.lng();

      if (lat === undefined || lng === undefined) {
        return null;
      }

      return {
        lat,
        lng,
      };
    } catch (error) {
      return null;
    }
  }
}
